// extracted by mini-css-extract-plugin
export var dropdown = "_q9-0";
export var imageWrapper = "_q9-3";
export var itemNameContainer = "_q9-1";
export var productImage = "_q9-2";
export var spinnerWrapper = "_q9-4";